module.exports = __webpack_public_path__ + "img/pick4_blue.b91abf3a.png";